import React from "react";
import style from './blackfridaylanding.module.scss';

const BlackFridayLanding = (props) => {

    const landingData = [
        { _id: 0, title: 'طرح شتاب فروش', amount: 'محصولات شما', description: '(ارزیابی پتانسیل فروش محصولات فعلی شما)', link: '/blackfriday/list/your-products', icon: 'newProduct', isLocked: false },
        { _id: 1, title: 'طرح افق‌های جدید', amount: 'محصولات گروه کالایی شما', description: '(ارزیابی و پیشنهادات در گروه کالایی مرتبط)', link: '/blackfriday/list/category-products', icon: 'inStock', isLocked: true },
        { _id: 2, title: 'طرح جهش کسب‌و‌کار', amount: 'محصولات پرفروش دیجی‌کالا', description: '(پرفروش‌ترین‌های دیجی‌کالا در ماه‌های اخیر)', link: '/blackfriday/list/all-products', icon: 'starProduct', isLocked: true }
    ]

    return (<div className={style.wrapper}>
        <div className={style.header}>
            <h1>ابزار هوشمند افزایش فروش</h1>
        </div>
        <div className={style.boxWrapper}>
            {landingData.map((data, dataIndex) => <a
                key={`dataIndex_${dataIndex}`}
                className={style.blueBox}
                href={data.isLocked ? '' : data.link}
                style={data.isLocked ? { filter: 'grayscale(90%)' } : {}}
            >
                <div className={style.iconWrapper}>
                    <div className={style[data.icon]}></div>
                </div>
                <div className={style.statsWrapper}>
                    <p className={style.title}>{data.title}</p>
                    <p className={style.amount}>{data.amount}</p>
                    <p className={style.description}>{data.description}</p>
                </div>
            </a>)}
        </div>

    </div>)
}
export default BlackFridayLanding